import React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import { Times } from '@styled-icons/fa-solid/Times';
import { Shield } from '@styled-icons/fa-solid/Shield';
import { device } from '../../constants/device-sizes';
import ModalButton from './ModalButton';
import TitleText from './TitleText';

const CloseButton = styled(Times)`
  cursor: pointer;
  position: absolute;
  width: 2.5rem;
  height: 2.5rem;
  top: 1rem;
  right: 1rem;
  margin: 1rem 1rem;
  font-size: 2rem;
  transition: all 0.2s linear;
  color: var(--clr-sec);
  :hover {
    color: red;
  }
`;

const ModalWrapper = styled.div`
  width: 100%;
  padding: 1rem;
  @media ${device.tablet} {
    width: 50%;
    position: auto;
    top: auto;
  }
  top: 0px;
  position: absolute;
`;

const ModalContent = styled.div`
  padding: 16px;
  background-color: var(--clr-bg);
  width: 100%;
  border-radius: 12px;
  shadow-opacity: 0.18;
  shadow-radius: 4px;
  shadow-color: #000;
  shadow-offset: 0px 4px;
  elevation: 10;
`;

const Description = styled.p`
  color: var(--clr-sec);
  font-size: 16px;
  text-align: center;
  margin: 1.5rem 0;
  line-height: 1.5;
`;

const ReasonList = styled.ul`
  color: var(--clr-sec);
  font-size: 14px;
  margin: 1.5rem 0;
  padding-left: 1.5rem;

  li {
    margin-bottom: 0.5rem;
    line-height: 1.4;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
`;

const ModalButtonSC = styled.div`
  cursor: pointer;
  flex-grow: 1;
  margin: 0 0.5rem;
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem 0;
  color: var(--clr-orange);
`;

const VpnWarningModal = ({ visible, onClose }) => {
  return (
    <Modal
      isOpen={visible}
      onRequestClose={onClose}
      style={{
        overlay: { zIndex: 1000, backgroundColor: 'rgba(0,0,0,0.5)' },
        content: {
          background: 'none',
          border: 'none',
          padding: 0,
          inset: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
      }}
      ariaHideApp={false}
    >
      <ModalWrapper>
        <ModalContent>
          <CloseButton onClick={onClose} />

          <TitleText>VPN Blocked</TitleText>

          <IconContainer>
            <Shield size={48} />
          </IconContainer>

          <Description>
            We've detected that you're using a VPN or proxy service. VentScape
            currently blocks all VPNs, as unfortunately trolls can use them to
            avoid bans.
          </Description>

          <ReasonList>
            <li>Please disconnect your VPN to use VentScape</li>
            <li>
              Note: iCloud Private Relay is also considered a VPN and is
              blocked.
            </li>
          </ReasonList>

          <ButtonContainer>
            <ModalButtonSC
              width='45%'
              as={ModalButton}
              isAffirmative={true}
              onClick={onClose}
            >
              Got it
            </ModalButtonSC>
          </ButtonContainer>
        </ModalContent>
      </ModalWrapper>
    </Modal>
  );
};

export default VpnWarningModal;
